import { useContext } from 'react';
import { ApplicationContext } from '../../store/context';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { lock_hooks } from '@axo/shared/data-access/hooks';
import { loan_application } from '@axo/shared/data-access/types';
import { loan_application_api } from '@axo/shared/data-access/api';

/**
 * @deprecated
 */
export function useLockAndOpenApplication(marketCountry: string) {
  const { dispatch } = useContext(ApplicationContext);
  const dataAccessContext = useContext(DataAccessContext);
  const acquireLock = lock_hooks.useLockApplication();
  return async function openApplication({
    LoanApplicationID,
    HumanReadableID,
  }: {
    LoanApplicationID: string;
    HumanReadableID: string;
  }) {
    const existingLock = await lock_hooks.fetchApplicationLock(
      dataAccessContext,
      marketCountry,
      LoanApplicationID,
    );
    if (!existingLock) {
      await acquireLock.mutateAsync({
        marketCountry,
        applicationID: LoanApplicationID,
      });
    }
    dispatch({
      type: 'Open application',
      scope: {
        parentType: 'navigation',
        id: LoanApplicationID,
      },
      payload: {
        humanReadableID: HumanReadableID,
        marketCountry,
      },
    });
  };
}

/**
 * @deprecated
 */
export function useLockAndOpenApplications(marketCountry: string) {
  const openAndLock = useLockAndOpenApplication(marketCountry);
  const api = useAPI();
  const getApplication = loan_application_api.getLoanApplication(api);

  return async function getApplications(applicationIDs: string[]) {
    const applicationsPromises = applicationIDs.map((id) => getApplication(id));
    const applications = await Promise.all(applicationsPromises);
    return applications
      .filter((app): app is loan_application.LoanApplication => !!app)
      .map((loanApp) => ({
        HumanReadableID: loanApp.HumanReadableID ?? '',
        LoanApplicationID: loanApp.ID,
      }))
      .map(openAndLock);
  };
}
